import React from "react";
import BaseButton from "./BaseButton";
import { UploadOutlined } from '@ant-design/icons';
import { Button } from 'antd';

const BaseUpload = (props) => <Button type="info" style={ { width: '10px' } } className={ "button-right-align" } { ...props } >{ props.text } <UploadOutlined /></Button>

export default BaseUpload;
